import { parseDate } from '@openphone/lib/date'
import dayjs from 'dayjs'

import type Service from '.'
import ScheduledMessageModel, {
  type CodableScheduledMessage,
} from './model/ScheduledMessageModel'
import type { ConversationModel } from './model/conversation'

export default class ScheduledMessageStore {
  constructor(private root: Service) {}

  getConversationFromScheduledMessage(
    scheduledMessage: ScheduledMessageModel,
  ): ConversationModel | null {
    const conversationId = scheduledMessage.body?.conversationId

    if (!conversationId) {
      return null
    }

    return this.root.conversation.collection.get(conversationId)
  }

  async send(scheduledMessage: CodableScheduledMessage): Promise<ScheduledMessageModel> {
    if (!scheduledMessage?.body) {
      throw new Error('Schedule message body was not provided')
    }

    if (!scheduledMessage?.sendAt) {
      throw new Error('Schedule message send date was not provided')
    }

    const to = scheduledMessage.body.to.map((item) => item.phoneNumber).join(',')

    const mediaUrl = scheduledMessage.messageMedia ?? []

    const response = await this.root.transport.communication.scheduledMessages.send({
      id: scheduledMessage.id ?? undefined,
      phoneNumberId: scheduledMessage.body.from.phoneNumberId,
      to,
      body: scheduledMessage.body.message.body,
      mediaUrl,
      activityId: scheduledMessage.body.activityId,
      conversationId: scheduledMessage.body.conversationId,
      sendAt: dayjs(scheduledMessage.sendAt).toISOString(),
      terminalCondition: scheduledMessage.terminalCondition ?? 'IfNoReply',
    })

    const scheduledMessageModel = new ScheduledMessageModel(response.message)

    if (response.message.id) {
      scheduledMessageModel.id = response.message.id
    }

    return scheduledMessageModel
  }

  async delete(scheduledMessage: ScheduledMessageModel) {
    const response = await this.root.transport.communication.scheduledMessages.delete({
      id: scheduledMessage.id,
    })

    return response
  }
}
